//function GetSuggestedProducts() {
//    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

//        $.ajax({
//            type: "GET",
//            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
//            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
//            cache: false,
//            success: function (dt) {

//                $(".Suggesteds").remove();

//                if (dt != "") {
//                    $(dt).insertBefore($(".SuggestAndLast"));
//                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-sm-6");
//                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-xs-12");
//                    $(".Suggesteds .Productsuggest .ProductList .Prd:gt(3)").addClass("hidden-xs");
//                }
//            }
//        });
//    }
//}

function GetSuggestedProducts() {

    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
            cache: false,
            success: function (dt) {

                dt = dt.replace("_buyuk", "_kucuk");

                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {

                    //$(".AutoGetSuggested").html(dt);

                    //$(".AutoGetSuggested .ProductList .Prd").addClass("col-sm-6");
                    //$(".AutoGetSuggested .ProductList .Prd").addClass("col-xs-12");
                    //$(".AutoGetSuggested .ProductList .Prd:gt(3)").addClass("hidden-xs");

                    $(".AutoGetSuggested").append(dt);

                    //$(".AutoGetSuggested .ProductList").removeClass("grid-wrapper").addClass("grid-wrapper-product-details");
                    //$(".AutoGetSuggested .ProductList .Prd").removeClass("grid").addClass("grid-product-details");
                    //$(".AutoGetSuggested .ProductList .Prd a .img2").remove();
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");

                }

                //if ($(window).width() < 767) {

                SuggestPrdSlider();
                //}


            }
        });
    }
}

function ModalImageSize() {

    var ModalWidth = $("#ZoomImage > .modal-dialog").width();
    $(".ProductBigSeen > img").width(ModalWidth);


}

function addQuantity() {
    $(".AmountOptions a").live("click", function () {
        var InputItem = $(this).closest(".AmountOptions").find("#Amount");
        if ($(this).hasClass("BasketPlus")) {
            InputItem.attr('value', parseInt(InputItem.val()) + 1);
        }
        if ($(this).hasClass("BasketMinus") && InputItem.val() > 0) {
            InputItem.attr('value', parseInt(InputItem.val()) - 1);
        }

    });
}

function GetHashImage() {

    //var CurHash = window.location.hash;

    //if (CurHash != undefined && CurHash.length > 0 && CurHash.indexOf("#C=") > 0) {
    //    CurHash = CurHash.replace("#", "");
    //    var newHash = CurHash.replace("#", "").split("=")[1];
    //    $colorID = $(".ProductDetail .Colors a[data-id=" + newHash + "]");

    //    if ($colorID.length > 0) {
    //        $colorID.trigger("click");
    //    }

    //}

    if (window.location.hash != undefined && window.location.hash != "") {

        var colorHash = window.location.hash.split("=");
        var ColorID = colorHash[1];

        currentColorID = $(".Colors a.active:first").attr("data-id");

        if (currentColorID == ColorID) {

            //RunSlickSlider();
        }

        if (currentColorID != ColorID) {

            if ($(".ProductDetail .Colors a[data-id='" + ColorID + "']").length > 0) {

                $(".ProductDetailImages img").remove();
                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");

            }

        }
        else if ($("#CurCatalogID").length > 0) {

            GetSuggestedProducts();
        }
    }
    else {
        //RunSlickSlider();
    }

}

var LastVisitedPrds = [];

function GetLastVisitedPrdView(productData) {

    if ($(".AutoGetLastVisited").length > 0) {

        //var prdDataList = "";
        //for (var i = 0; i < productData.length; i++) {

        //    prdDataList += "lastviewedPrds.[" + i + "].Amount=" + productData[i].Amount;
        //    LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, ProductName: _prdname });

        //}
        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProductsView",
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {


                $(".LastViewedProducts.AutoSetted").remove();

                if (dt != "") {

                    //$(".AutoGetLastVisited .container").append(dt);

                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
                    $(".LastViewedProducts .ProductList .Prd a .img2").remove();

                }

            }
        });
    }
}

$("#SingOut").live("click", function (e) {
    if (!isAppleMobile()) {
        localStorage.removeItem("LastVisitedPrds");
    }
});

function SetLastVisitedProductsStorage() {
    if (typeof (Storage) !== "undefined") {

        if ($(".ProductHeader:first").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now)
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem("LastVisitedPrds");
                    //localStorage.clear();
                    localStorage.setItem('prdLastSetupTime', now);
                    console.log('Local Storage silindi! ProductDetails.js');
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = localStorage.LastVisitedPrds;

            if (LastVisitedPrds == undefined) {
                LastVisitedPrds = [];
            } else {
                LastVisitedPrds = JSON.parse(LastVisitedPrds);
            }

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {

                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg.replace("_1_", "_2_"), ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }
                localStorage.LastVisitedPrds = JSON.stringify(LastVisitedPrds);
            }

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {

                GetLastVisitedPrdView(LastVisitedPrds);
            }
        }
        else {
            // 'fastLocalStorageUpdate' değeri ile versiyon geçişinden(JimmyKey V2 geçişi) sonra kullanıcı tarafında yaşanan siteye giriş hatalarının düzeltilmesi amaçlandı.
            var fastUpdate = localStorage.getItem('fastLocalStorageUpdate');

            if (fastUpdate === null || fastUpdate === true) {
                localStorage.clear();
                localStorage.setItem('fastLocalStorageUpdate', false);

                console.log('"fastLocalStorageUpdate" localStorage üzerinde işlem yapıldı!');
            }
        }

    } else {
        console.warn("Tarayıcının localstorage desteği bulunmuyor.");
    }

}

//function GetLastVisitedProducts() {

//    var colorHash = window.location.hash.split("=");
//    var ColorID = colorHash[1];

//    if (ColorID == undefined || colorHash == undefined || colorHash.length <= 0) {
//        ColorID = $(".Colors a.active:first").attr("data-id");
//    }

//    if ($(".AutoGetLastVisited").length > 0) {
//        $.ajax({
//            type: "GET",
//            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProducts",
//            data: "VisitedPrdID=" + $("#ProductID").val() + "&ColorID=" + ColorID,
//            cache: false,
//            success: function (dt) {
//                $(".LastViewedProducts.AutoSetted").remove();

//                if (dt != "") {
//                    $(".AutoGetLastVisited").append(dt);
//                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
//                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
//                    $(".LastViewedProducts .ProductList .Prd:gt(3)").addClass("hidden-xs");
//                }
//            }
//        });
//    }
//}

function Get5thAngleCombine() {

    if ($(".CombineProductsOnPd .Prd").length > 0) {

        var imagePath1thAngle = $(".CombineProductsOnPd .Prd:first .img1").attr("src");

        var ImgExist = false;
        var BeginAngle = 5;
        var NewImagePathAngle = "";
        $curImg = $(".CombineProductsOnPd .ProductList .Prd:first .img1");

        if (!ImgExist && $curImg.attr("src") != undefined && $curImg.attr("src").indexOf("5_buyuk") <= 0) {

            NewImagePathAngle = imagePath1thAngle.replace("1_buyuk", "1_buyuk");

            ImgExist = true;

            $curImg.attr("src", NewImagePathAngle);

            $curImg.error(function () {
                $curImg.attr("src", imagePath1thAngle);
            });
        }
    }
}

function ReplaceCombineProducts() {

    if ($(".CombineProductsOnPd .Prd").length > 0) {

        //$(".CombineProductsOnPd .Prd:first").append('<div class="equals">=</div>');

        // Kombindeki ilk ürünün fiyat bilgilerini sildiği için kapatılan satırlar
        //$(".CombineProductsOnPd .Prd:first > a").attr("href", $(".CombineButton").attr("href"));
        //$(".CombineProductsOnPd .Prd:first .PName").html($(".CombineButton").attr("data-title"));

        //$priceSpan = $(".CombineProductsOnPd .Prd:first .PPrice span").clone();
        //$combineButton = $(".CombineInfoPd .CombineButton").clone();

        //$(".CombineProductsOnPd .Prd:first .PPrice").remove();
        //$(".CombineProductsOnPd .Prd:first").append($combineButton);

        //$(".CombineProductsOnPd .Prd:gt(0)").addClass("SmallPrd");

        Get5thAngleCombine();
    }
}

function DetailResizing() {

    $(".CombineProductsOnPd .Productsuggest .ProductList").addClass("col-xs-24");


    if ($(window).width() <= 991) {

        $(".ProductDetailsMainImage ul li img").each(function () {
            $(this).attr("src", $(this).attr("src").replace("_buyuk", "_614x805"))
        });
    }


    $(window).resize(function () {


        if ($(window).width() <= 991) {

            $(".ProductDetailsMainImage ul li.ImgArea img").each(function () {
                $(this).attr("src", $(this).attr("src").replace("_buyuk", "_614x805"))
            });
        }
    });
}

function AskQuestions() {

    $("body").on("click", ".AskQuestion", function () {
        $("#AskQuestion").modal();
    });

    $('#AskQuestion').on('shown.bs.modal', function () {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/AskQuestions",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                $("#AskQuestion  .formArea").html("");

                $("#AskQuestion  .formArea").html(dt);
                $("#AskQuestion  .formArea .HiddenItems").find("#ColorID").val($(".Colors div a.active").data("id"));
                $("#AskQuestion  .formArea .HiddenItems").find("#ProductID").val($(".Prices #ProductID").val());
            }
        });
    });
}

function SizeTable() {

    $(".SizeTable").live("click", function () {
        $("#SizeTable").modal();
    });
}

function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }
    });
}

function CombinePrdSlider() {
    var slidesToShowNumber = 2;

    if ($(window).width() < 767) {
        slidesToShowNumber = 1;
    }
    $(".CombineProductsOnPd img.img2").remove();

    $(".CombineProductsOnPd .ProductList .ProductList").slick({
        nextArrow: '<div class="PrdDetayImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdDetayImgLeft left-arrow"></div>',
        slidesToShow: slidesToShowNumber,
        slidesToScroll: 1,
        arrows: true,
        useTransform: false,
    });
}

function SuggestPrdSlider() {
    //$(".AutoGetSuggested img.img2").remove();

    //$(".AutoGetSuggested .ProductList .ProductList").slick({
    //    nextArrow: '<div class="PrdDetayImgRight right-arrow"></div>',
    //    prevArrow: '<div class="PrdDetayImgLeft left-arrow"></div>',
    //    slidesToShow: 2,
    //    slidesToScroll: 1,
    //    arrows: true,
    //    useTransform: false,
    //});
}

function Slider() {
    //if ($(window).width() > 991) {
    $('.ProductDetailsMainImage ul').slick({
        nextArrow: '<div class="PrdImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdImgLeft left-arrow"></div>',
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        lazyLoad: 'ondemand'
    });

    $('.SmallProductImages ul').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.ProductDetailsMainImage ul',
        prevArrow: '<div class="yukariIcon"></div>',
        nextArrow: '<div class="asagiIcon"></div>',
        focusOnSelect: true,
        vertical: true,
        lazyLoad: 'ondemand'
    });
    //}

}

function AddToFavoriteNewPd() {
    var ColorID = $("#ColorID").val();
    var ProductID = $("#ProductID").val();

    $("#ProductDetailDivi").find(".passiveFavorite").live("click", function () {
        $That = $(this);

        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");

                        //#region Related Datalayer Add To Favorite Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion
                    }
                    else if (dt.Sonuc == false) {
                        alert('Favorilere eklemek için giriş yapınız!');
                    }
                },
                error: function (httpObj, textStatus) {

                    //if (httpObj.status == 401) {
                    //    alert('Favorilere Eklemek için giriş yapınız.');
                    //}
                    //else {
                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    //}
                }
            });
        }
    });
}

function removeFavoriteNewPd() {
    var ColorID = $("#ColorID").val();
    var ProductID = $("#ProductID").val();

    $("#ProductDetailDivi").find(".activeFavorite").live("click", function () {
        $That = $(this);

        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'productID=' + ProductID + '&colorID=' + ColorID + '&isDetail=true',
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");

                        //#region Related Datalayer Remove From Favorite Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion
                    }
                },
                error: function (httpObj, textStatus) {
                    if (httpObj.status == 401) {
                        alert('Favorilerden çıkartmak için giriş yapınız.');
                    }
                    else {
                        alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }
                }
            });
        }
    });
}

$("body").on("submit", ".AskQuestionForm", function (e) {

    $.ajax({
        type: 'post',
        url: $(".AskQuestionForm").attr("action"),
        data: $(".AskQuestionForm").serialize(),
        async: true,
        success: function (dt) {

            if (dt.Sonuc == true) {

                $("#Infos").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                $(".AskQuestionForm").hide();

            }
            else {

                $("#AlertResult").addClass("alert-danger");
                $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
            }

        },
        error: function () {

            alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
        }
    });

    e.preventDefault();
    return false;

});

//function ImageFix() {
//    var imageMoved = false;
//    $('.ImgArea img').on('ready', function () {
//        var isHorizontal = $(this).width() > $(this).height();
//        if (isHorizontal && !imageMoved) {
//            imageMoved = true;
//            $li = $(this).closest("li");
//            $li.insertBefore($(".ProductDetailsMainImage ul li:eq(2)"));
//            $img = $li.find("img");

//            $img.attr("src", $img.attr("src").split('?')[0]);
//            $li.css("width", "100%");
//        }
//    });
//}

$('#StoreStocksbtn').live("click", function (e) {
    var ProductID = $("#ProductID").val();
    var ColorID = $("#ColorID").val();
    var SizeID = $("#StoreStockOptionsDetail select[name='BedenMagazaAra']").val();

    if ((SizeID != null && SizeID != undefined && SizeID != "") && (ColorID != null && ColorID != undefined && ColorID != "") && (ProductID != null && ProductID != undefined && ProductID != "")) {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetStoreStocks?ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID,
            success: function (data) {

                $(".StoreStockBody").html(data);

            }
        });
    }
    else {

        if (SizeID == null || SizeID == undefined || SizeID == "") {
            alert("Lütfen Beden Seçiniz..");
        }
        else if (ColorID == null || ColorID == undefined || ColorID == "") {
            alert("Lütfen Renk Seçiniz..");
        }
        else if (ProductID == null || ProductID == undefined || ProductID == "") {

            alert("Bir hata oluştu lütfen sayfayı yenileyerek tekrar deneyiniz.");

        }

    }
});

function RemoveBasketCount() {
    $(".ProductDetailsMainImage .BasketCountPopup").fadeOut("slow", function () {
        $(this).remove();
    });
}

function AddBasketCount() {
    var basketCount = $("#BasketCount").val();
    if (basketCount != '' && basketCount >= 2 && $(window).width() > 767) {

        var popup = $("<div class=\"BasketCountPopup\">" +
            "<div class=\"trinagleOuther\">" +
            "<span class=\"glyphicon glyphicon-triangle-top\"></span>" +
            "</div>" +
            "<img src=\"/Images/JMK/Icons/sepet_mobile_yeni.png\"/>"
            + $("#BasketCountMessage").val()
            + "</div>").hide();
        popup.appendTo($(".ProductDetailsMainImage")).fadeIn(1500);
        window.setTimeout(RemoveBasketCount, 9000)
    }
}

$(document).ready(function () {

    //var imageMoved = false;

    //$('.ImgArea img').on('load', function () {

    //    var isHorizontal = $(this).width() > $(this).height();

    //    if (isHorizontal && !imageMoved) {
    //        imageMoved = true;
    //        $li = $(this).closest("li");
    //        $li.insertBefore($(".ProductDetailsMainImage ul li:eq(2)"));
    //        $img = $li.find("img");

    //        $img.attr("src", $img.attr("src").split('?')[0]);
    //        $li.css("width", "100%");
    //    }

    //});

    $(".CombineProductsOnPd .Prd:eq(1)").addClass("col-md-offset-2");

    AskQuestions();
    SizeTable();
    Slider();

    //window.setTimeout(AddBasketCount, 2000);

    //ImageFix();
    AddToFavoriteNewPd();
    removeFavoriteNewPd();

    $miniImage = $('.SmallProductImages ul');

    //if ($(window).width() < 767) {
    //CombinePrdSlider();

    //}

    DetailResizing();

    //if (!isAppleMobile()) {
    //    SetLastVisitedProductsStorage();
    //}

    GetSuggestedProducts();
    //GetLastVisitedProducts();
    ReplaceCombineProducts();
    ModalImageSize();
    BasketButtonFixed();
    ShowZoomImage();

    if ($(".CombineProductsOnPd .ProductList .Prd").length > 0) {
        ////$(".CombineProductsOnPd .ProductList .Prd:first").removeClass("col-xs-12").addClass("col-xs-24");
        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 3) {
        //    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-7");
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-6").addClass("col-md-7");
        //}

        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 5) {
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-4").addClass("col-md-5");
        //}

        //if ($(".CombineProductsOnPd .ProductList .Prd").size() == 4) {

        //    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-6").addClass("col-md-5");
        //    $(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-5").addClass("col-md-6");

        //}

        //$(".CombineProductsOnPd .ProductList .Prd:first-child").addClass("PrdFirstPadding");
        ////$(".CombineProductsOnPd .ProductList .Prd:first-child").removeClass("col-md-6").addClass("col-md-7");
        $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-6");
    }

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {


        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = $("#Amount").val();
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        var ProductName = $(".ProductHeader").html();
        var price = $(".PriceItem").html();
        var priceCurrency = $(".PriceCurreny").html();
        var catalogTree = $(".CatalogTree").html();

        catalogTree = catalogTree.replace('&gt;', '>');
        catalogTree = catalogTree.replace('&gt;', '>');
        catalogTree = catalogTree.replace('&amp;', '>');

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=1" + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        //#region Related Datalayer Add To Basket Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion
                        // Facebook pixel

                        fbq('track', 'AddToCart', {
                            content_name: ProductName,
                            content_category: catalogTree,
                            content_ids: [ProductID],
                            content_type: 'product',
                            value: price,
                            currency: priceCurrency
                        });
                        // Facebook pixel
                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus > #UserAndBasket").html(dt);

                                AddSearchBox();

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");

                                setContentHeight();
                            }
                        });

                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {
                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);
                        }

                        if (UseTagManager) {
                            SendCartAddEvent('');
                        }
                    }
                    else {
                        alert(dt.IslemSonucAciklama);
                    }
                }
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");
                //$("body").addClass("BackDropped");

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });

    //if (isMobile(false)) {

    //    $("#Basket").on("hover", function (e) {

    //        $(".AddToBasket.ProductDetails  #Basket").trigger("click");


    //    });

    //}

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {

        $(this).parents(".Sizes").find(".Name").html($(this).attr("data-name"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        //$(this).parent().find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).addClass("active");



        if ($(".NewPD").length > 0) {

            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");

            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");


            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }


            //$(".AmountOptions").addClass("open");

            $(".AddToBasket button").removeClass("NotSelected");


            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {

                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");

            $(".AddToBasket").removeClass("PleaseSelect");

            $("#PrdBlackBg").hide();

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }

        }

        if ($(".LastProducts").length > 0) {

            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
                data: params,
                success: function (data) {

                    if (data != "0" && data != 0) {

                        var prdCls = "More";

                        $(".LastProducts").removeClass("One");
                        $(".LastProducts").removeClass("Two");
                        $(".LastProducts").removeClass("More");
                        $(".LastProducts").removeClass("Limited");

                        $(".LastX").html(data);
                        $(".LastPrdHint").html($(".LastPrdHint").attr("data-more"));

                        //if (data.length > 1) {
                        //    $(".LastX").css("margin-left", "2px");
                        //}
                        //else {
                        //    $(".LastX").css("margin-left", "4px");
                        //}

                        switch (data) {

                            case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                            case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                            case "4": prdCls = "Limited"; break;
                        }

                        $(".LastProducts").addClass(prdCls);
                        $(".LastProducts").show();
                    }
                }
            });
        }
    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {

        $(".SizeOptions .ONE.SIZE").trigger("click");
        //$(".SizeAndAmount").hide();
    }

    $("a.NotifyWhen").live("click", function myfunction() {

        $("#NotifyModal .modal-body").empty();
        $("#NotifyModal").modal("show");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetListForRemind?ProductID=" + $("#ProductID:first").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $(this).parent().parent().parent().find("input[name=SizeIDs]").val(),
            cache: true,
            success: function (data) {
                $("#NotifyModal .modal-body").html(data);
                $(".NotifyColors a:first").trigger("click");
            }
        });
    });

    var lastColorID = 0;

    if ($('.ProductDetail .Colors a.active').length > 0) {
        $(".ProductDetail .Colors .Name").html($('.ProductDetail .Colors a.active').first().attr("data-name"));
    }

    //Favorilere Ekle
    //$(".PrLike.add").live("click", function () {

    //    if (!$(this).hasClass("active")) {

    //        var ColorID = $("#ColorID").val();
    //        var ProductID = $("#ProductID").val();
    //        var Notify = $(this).attr("data-notify");

    //        var LangID = $("#LangID").val();

    //        var clickedItem = $(this);

    //        if (ColorID != undefined && ProductID != undefined && ColorID != "" && ProductID != "") {

    //            $.ajax({
    //                url: '/Cart/AddToFollowList',
    //                data: "colorID=" + ColorID + "&productID=" + ProductID + "&langID=" + LangID,
    //                dataType: 'json',
    //                success: function (dt) {

    //                    if (dt.Sonuc == true) {

    //                        $("button.PrLike").text($("button.PrLike").attr("data-infavtext"));

    //                        $(clickedItem).addClass("active");
    //                        $(clickedItem).attr("data-followid", dt.Deger1);
    //                        $(clickedItem).val(dt.IslemSonucAciklama);
    //                        $('.LikeCount').html(dt.Deger4);

    //                        if ($(".HeartIcon").length > 0) {
    //                            $(".HeartIcon").removeClass("Blank");
    //                            $(".HeartIcon").trigger("click");
    //                        }
    //                    }
    //                    else {

    //                        alert(dt.IslemSonucAciklama);
    //                    }
    //                }
    //            });
    //        }
    //        else {

    //            if (ColorID == undefined || ColorID == "") alert("Lütfen bir Renk Seçininiz");
    //            if (ProductID == undefined || ProductID == "") alert("Ürün Bulunamadı");
    //        }
    //    }
    //});

    ////Favorilerden Çıkart
    //$(".PrLike.active").live("click", function () {

    //    var clickedItem = $(this);

    //    var Silid = $(this).attr("data-id");

    //    if ($(this).attr("data-followid").length > 0) {

    //        Silid = $(this).attr("data-followid");

    //    }

    //    var clickedIcon = $(this);

    //    var LangID = $("#LangID").val();

    //    $.ajax({
    //        url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
    //        data: 'id=' + Silid + "&langID=" + LangID,
    //        dataType: 'json',
    //        success: function (dt) {

    //            if (dt.Sonuc == true) {

    //                $(clickedIcon).removeClass("active");
    //                $(clickedIcon).addClass("add");
    //                $("button.PrLike").text($("button.PrLike").attr("data-addtext"));
    //            }
    //            else {
    //                alert(dt.IslemSonucAciklama);
    //            }

    //        }
    //    });
    //});

    GetHashImage();

    $(window).bind('hashchange', function (e) {
        GetHashImage();
    });

    if ($("div.row.Products").length > 0) {

        var ScrollSize = +70;
        var offsetTop = 0;

        if (isMobile(true)) {
            ScrollSize = 50;
            offsetTop = $(".ToogleFilters:first").offset().top;

        } else if ($("#FilterForm").length > 0) {

            //offsetTop = $("#FilterForm").offset().top
        }

        if (isMobile(true)) {

            $('html, body').animate({
                scrollTop: offsetTop - ScrollSize
            }, 500);
        }
    }

    //if (window.location.hash != undefined && window.location.hash != "") {
    //    GetHashImage();
    //}

    //Amount Option Change
    //$('.AmountOptions .BasketPlus, .AmountOptions .BasketMinus').live("click", function () {

    //    if ($(this).closest(".AmountOptions").hasClass("open") == false) {
    //        return;
    //    }
    //    console.log($(this).attr("class"));

    //    if ($(this).attr("class") == "BasketPlus") {
    //        console.log("123");
    //        if ($(".AmountOptions #Amount").val() >= 9) {
    //            $(".AmountOptions #Amount").val(9)
    //        }
    //        else {

    //            $(".AmountOptions #Amount").val(parseInt($(".AmountOptions #Amount").val()) + 1);
    //        }
    //    }
    //    else {
    //        if ($(".AmountOptions #Amount").val() > 1) {
    //            $(".AmountOptions #Amount").val(parseInt($(".AmountOptions #Amount").val()) - 1);
    //        }
    //        else {
    //            $(".AmountOptions #Amount").val(1)
    //        }
    //    }
    //});

    addQuantity();

    $('.ProductDetail #Amount').live("keyup", function () {

        var yeniAdet = $(this).val();
        $adetKutusu = $(this);

        if (!isNumeric(yeniAdet)) {
            yeniAdet = 1;
        }

        if (yeniAdet <= 1) {

            yeniAdet = 1;
            $adetKutusu.val(1);
        }
        else if (yeniAdet >= 9) {

            yeniAdet = 9;
            $adetKutusu.val(9);
        }
    });

    $(".AmountOptions #Amount").live("change", function () {

        if ($(".AmountOptions #Amount").val() < 1) {

            $(".AmountOptions #Amount").val(1);
        }
        else if ($(".AmountOptions #Amount").val() >= 9) {

            $(".AmountOptions #Amount").val(9);
        }
    });

    $(".SmallProductImages ul li img").live("click", function () {

        $(".SmallProductImages ul li img").each(function () {
            $(this).removeClass("Selected");
        });

        $(this).addClass("Selected");
        $Index = $(this).parent().index();
        $(".ProductDetailImages ul li.ImgArea").addClass("gizli");
        $(".ProductDetailImages ul li.ImgArea").each(function () {
            if ($Index === $(this).index()) {
                $(this).removeClass("gizli");
            }
        });
    });

    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $miniImage.slick("slickGoTo", currentSlide);

        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {

                $("img", this).addClass("Selected");

            }
            else {

                $("img", this).removeClass("Selected");
            }
        });
    });

    $('.ProductDetailImages .ImgArea a').live("click", function (e) {

        if (isMobile(true) || $(this).closest("#QuickLookModal").length > 0) {

            return false;
            e.preventDefault();
        }
    });

    if ($(window).width() > 1000 && $(".cloudzoomManuel").length > 0 && $("#QuickLookModal").length <= 0) {

        $(".cloudzoomManuel:first").addClass("cloud-zoom").CloudZoom();

    }

    if ($(".Productsuggest").length > 0 && $(".backdrop").length > 0) {

        $(".Productsuggest > .ProductList .Prd").addClass("col-sm-8");
        $(".Productsuggest > .ProductList .Prd").addClass("col-xs-12");
        //$(".Productsuggest > .ProductList .Prd:gt(3)").addClass("hidden-xs");
    }


    if ($(".ProductLastViewedCon").length > 0 && $(".backdrop").length > 0) {

        $(".ProductLastViewedCon .Prd").addClass("col-sm-6");
        $(".ProductLastViewedCon .Prd").addClass("col-xs-12");
        $(".ProductLastViewedCon .Prd:gt(3)").addClass("hidden-xs");
    }

    $("a.SizeTableLink").click(function () {

        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");

        $("#WarningModal").modal("show");

        var ProductID = $(this).closest(".ProductName").next(".CombineColors").find(".ProductID").val();
        var ColorID = $(this).closest(".ProductName").next(".CombineColors").find(".ColorID").val();

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/SizeChart?ProductID=" + ProductID + "&ColorID=" + ColorID,
            success: function (data) {

                $("#WarningModal .modal-body").html(data);

            }
        });

    });

    $(".ProductDetailImages .PrdImgRight").click(function (e) {

        $("#AditionalDescription").remove();

        $currentObject = $(".ProductDetailImages ul li.ImgArea");
        if ($currentObject.not(".mobile-hidden").index() == ($currentObject.length - 1)) {

            $currentObject.addClass("mobile-hidden").first(".ImgArea").removeClass("mobile-hidden");

        } else {

            $currentObject.not(".mobile-hidden").addClass("mobile-hidden").next(".ImgArea").removeClass("mobile-hidden");

        }

        $(".SmallProductImages ul li img").each(function () {
            $ItemIndex = $currentObject.not(".mobile-hidden").index();
            if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                $(this).addClass("Selected");
            }

            $(".SmallProductImages ul li img").each(function () {
                if ($(this).parent().index() != $ItemIndex) {
                    $(this).removeClass("Selected");
                }

            });
        });


    });

    $(".ProductDetailImages .PrdImgLeft").click(function (e) {

        $("#AditionalDescription").remove();

        $currentObject = $(".ProductDetailImages ul li.ImgArea");

        if ($currentObject.not(".mobile-hidden").index() == 0) {

            $currentObject.addClass("mobile-hidden");
            $currentObject.last().removeClass("mobile-hidden");

        } else {

            $currentObject.not(".mobile-hidden").addClass("mobile-hidden").prev(".ImgArea").removeClass("mobile-hidden");

        }

        $(".SmallProductImages ul li img").each(function () {


            $ItemIndex = $currentObject.not(".mobile-hidden").index();
            if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                $(this).addClass("Selected");
            }

            $(".SmallProductImages ul li img").each(function () {
                if ($(this).parent().index() != $ItemIndex) {
                    $(this).removeClass("Selected");
                }

            });
        });

    });


    //if ($(window).width() < 993) {


    //    $(".ProductDetailImages .ImgArea  img").hammer().on("swipeleft", function (e) {

    //        $(".PrdImgLeft").trigger("click");
    //        e.stopPropagation();
    //        e.preventDefault();
    //    });


    //    $(".ProductDetailImages .ImgArea  img").hammer().on("swiperight", function (e) {

    //        $(".PrdImgRight").trigger("click");
    //        e.stopPropagation();
    //        e.preventDefault();
    //    });

    //}


    var isOpen = false;
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {

        var Amount = $(".PriceItem:first").html();
        var isPr = $(this).hasClass("PrInstallmentOptions");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(",", ""),
            success: function (data) {

                isOpen = !isOpen;
                $(".InstallmentBody").html(data);
                if (isPr) {
                    $("#PdInstallmentOptionsDetail").addClass("collapse in");
                }

                if (isOpen) {

                    $('html, body').animate({
                        scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
                    }, 500);
                }

            }
        });

    });


    $(".PrAdvantages a").click(function (e) {
        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");
        $("#WarningModal").modal("show");
        var ProductID = $("#ProductID").val();
        var ColorID = $("#ColorID").val();
        var Amount = parseFloat($(".PriceItem:first").html());

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAdvantages?ProductID=" + ProductID + "&ColorID=" + ColorID + "&Amount=" + Amount,
            success: function (data) {
                $("#WarningModal .modal-title").hide();
                $("#WarningModal .modal-body").html(data);
            }
        });
    });



    function ShowZoomImage() {

        if ($(window).width() >= 600) {

            $(".ProductDetailImages .ProductDetailsMainImage ul li img").die("click").live("click", function () {
                $ClickedImage = $(this);
                $('.ProductBigSeen').empty();
                $('.ProductBigSeen').html("");
                $("#ZoomImage").modal();
            });
            $('.ProductDetailImages .ProductDetailsMainImage ul li').removeClass('fancybox');
        }
        else {
            $(".ProductDetailImages .ProductDetailsMainImage ul li img").die("click");
            $('.ProductDetailImages .ProductDetailsMainImage ul li').addClass('fancybox');
        }
    }

    $(window).resize(ShowZoomImage).trigger('resize');




    $("#ZoomImage .closeImage").live("click", function () {
        $("#ZoomImage").modal("toggle");
    });

    $("#ZoomImage .PrdImgRight").live("click", function (e) {

        $selectedObject = $(".ProductImageList li.selectedImage");
        $currentObject = $(".ProductImageList li");
        $nextObject = $(".ProductImageList li.selectedImage").next();

        if ($currentObject.size() - 1 == $selectedObject.index()) {
            $selectedObject.removeClass("selectedImage");
            $currentObject.first().addClass("selectedImage");
        }
        else {
            $selectedObject.removeClass("selectedImage");
            $nextObject.addClass("selectedImage");
        }


    });

    $("#ZoomImage .PrdImgLeft").live("click", function (e) {

        $selectedObject = $(".ProductImageList li.selectedImage");

        $currentObject = $(".ProductImageList li");

        $prevObject = $(".ProductImageList li.selectedImage").next();

        if ($currentObject.size() - 1 == $selectedObject.index()) {

            $currentObject.first().addClass("selectedImage");
            $selectedObject.removeClass("selectedImage");
        }
        else {
            $selectedObject.removeClass("selectedImage");
            $prevObject.addClass("selectedImage");
        }

    });

    $('#ZoomImage').on('show.bs.modal', function () {
        $ImageCounter = 0;
        $BigImageUrl = $ClickedImage.attr("src").replace("_614x805", "_buyuk");
        $(".ProductBigSeen").append('<ul class="ProductImageList"></ul>');
        $(".ProductBigSeen").append('<ul class="SmallImageList"></ul>');
        $(".ProductBigSeen").append("<div class='PrdImgLeft'></div>");
        $(".ProductBigSeen").append("<div class='PrdImgRight'></div>");
        $(".ProductDetailsMainImage ul li.ImgArea img").each(function () {

            if (!$(this).parent().hasClass("slick-cloned")) {

                var PImageWrapper = $("<li></li>");
                var PSImageWrapper = $("<li></li>");
                if ($(this).first().attr("src").replace("_614x805", "_buyuk") == $BigImageUrl) {
                    PImageWrapper.addClass("selectedImage");
                    PSImageWrapper.addClass("selectedImage");
                }

                var img = $(this).attr('data-lazy');
                if (typeof img == typeof undefined || img == false) {
                    img = $(this).attr('src');
                }

                PImageWrapper.append($("<img class='ZoomModalImages' />").attr("src", img.replace("_614x805", "_buyuk")));
                $(".ProductBigSeen .ProductImageList").append(PImageWrapper);

                PSImageWrapper.append($("<img class='ZoomModalSmallImages' />").attr("src", img.replace("_buyuk.jpg", "_kucuk.jpg")));

                $(".ProductBigSeen .SmallImageList").append(PSImageWrapper);

            }

        });

        ModalImageSize();

    });

    $(".SmallImageList li").live("click", function () {
        var ImageIndex = $(this).index();
        $(".ProductImageList li").removeClass("selectedImage");
        $(".SmallImageList li").removeClass("selectedImage");
        $(this).addClass("selectedImage");
        $(".ProductImageList li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("selectedImage");
            }
        });

    });

    $('#ZoomImage').on('hidden.bs.modal', function () {
        //$('.ProductBigSeen').slick('unslick');
        $('.ProductBigSeen').empty();
        $('.ProductBigSeen').html("");
        $(".ThumbImageList").empty();
    })

    $(".ThumbImageList li img").live("click", function (event) {
        event.stopPropagation();
        $sliderSlick.slick("slickGoTo", $(this).parent().index());

        $(".ThumbImageList li img").each(function () {

            $(this).removeClass("ThumbActive");

        });

        $(this).addClass("ThumbActive");

    });

    $('.ProductBigSeen').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $(".ThumbImageList li img").each(function () {
            if ($(this).parent().index() == currentSlide) {
                $(this).addClass("ThumbActive");
            }
            else {
                $(this).removeClass("ThumbActive");
            }
        });
    });

    $(window).resize(function () {
        ModalImageSize();
    });
    var selector = '.fancybox.slick-slide:not(.slick-cloned)';
    $().fancybox({
        selector: selector
    });
});